import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Typography } from "antd";
import { DataWorkOffersCategories } from "../../../redux/@types";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { workOffersCategoriesService } from "../../../shared/services";
import { useWorkOffersCategories, useTableWorkOffersCategories } from "../hook";

const { Title } = Typography;

export const TableWorkOffersCategories = () => {
  const { changeWorkOffersCategoriesForUpdate, showDeleteConfirm } =
    useTableWorkOffersCategories();
  const { setTableProps, updateStatus, isLoading } = useWorkOffersCategories();

  const columns: TableColumns<DataWorkOffersCategories> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 9,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
            disabled={isLoading}
              onClick={()=>{
                if(item.status === "active"){
                  updateStatus("inactive", item.id)
                }else if( item.status === "inactive"){
                  updateStatus("active", item.id)
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Posición",
      width: 6,
      dataIndex: "position",
      key: "position",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeWorkOffersCategoriesForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataWorkOffersCategories>
      columns={columns}
      scroll={{ x: 'max-content' }}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={workOffersCategoriesService}
      onLoad={setTableProps}
    />
  );
};
